// Generated from SVG to Code Figma Plugin

export const BaseFillFolder = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.1412 6.01963V11.0143C23.1412 11.3036 22.9067 11.5381 22.6174 11.5381H1.37928C1.08999 11.5381 0.855469 11.3036 0.855469 11.0143V4.36353C0.879731 4.09528 1.00958 3.84721 1.21701 3.67284C1.42444 3.49847 1.69283 3.41178 1.96427 3.43146H11.3602C11.7647 3.41653 12.1465 3.61433 12.3653 3.95114C12.584 4.28796 12.8867 5.01474 13.5712 5.01474C14.2557 5.01474 21.9607 4.98492 21.9607 4.98492C22.5708 4.96159 23.0912 5.41783 23.1412 6.01963Z"
      fill="#2389DC"
    />
    <path
      d="M1.75307 7.45068H22.2436C22.8423 7.45068 23.1412 7.74645 23.1412 8.33798V19.8271C23.1412 20.4186 22.8423 20.7144 22.2436 20.7144H1.75307C1.15435 20.7144 0.855469 20.4186 0.855469 19.8271V8.33798C0.855469 7.74645 1.15435 7.45068 1.75307 7.45068Z"
      fill="#6BBCFF"
    />
  </svg>
);
